import { IconProps } from "../types";

export const HomeIcon: React.FC<IconProps> = ({ uuid, fillColor }) => {
  return (
    <svg
      id={`home-icon-${uuid}`}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        id={`home-icon-path-${uuid}`}
        d="M20 20V9.13199L12 4.33199L4 9.13199V20H8V17.25C8 16.1891 8.42143 15.1717 9.17157 14.4216C9.92172 13.6714 10.9391 13.25 12 13.25C13.0609 13.25 14.0783 13.6714 14.8284 14.4216C15.5786 15.1717 16 16.1891 16 17.25V20H20ZM14 22V17.25C14 16.7196 13.7893 16.2108 13.4142 15.8358C13.0391 15.4607 12.5304 15.25 12 15.25C11.4696 15.25 10.9609 15.4607 10.5858 15.8358C10.2107 16.2108 10 16.7196 10 17.25V22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V9.13199C2 8.78662 2.08943 8.44713 2.25959 8.14659C2.42976 7.84604 2.67485 7.59468 2.971 7.41699L10.971 2.61699C11.2818 2.43049 11.6375 2.33197 12 2.33197C12.3625 2.33197 12.7182 2.43049 13.029 2.61699L21.029 7.41699C21.3252 7.59468 21.5702 7.84604 21.7404 8.14659C21.9106 8.44713 22 8.78662 22 9.13199V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H14Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
